import { useNavigate, useRouteError } from 'react-router';

import { ErrorScreenWrapper } from '../ErrorScreenWrapper';

const RouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  return (
    <ErrorScreenWrapper
      systemErrorProps={{
        isError: true,
        systemErrorScreenProps: {
          errorMsg: (error as Error)?.message,
          onRetry: () => {
            navigate(0);
          },
        },
      }}
    >
      {null}
    </ErrorScreenWrapper>
  );
};

export default RouteErrorBoundary;
